import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, memo } from 'react';
import { Image, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import dayjs from 'dayjs';
import BluePax from '../../../../images/bluepax-logo.png';
;
export const DocumentFive = memo(({ pharmacy, traderInfo, }) => {
    const styles = StyleSheet.create({
        container: {
            padding: 40,
        },
        imageContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
        },
        image: {
            width: 200,
        },
        entryContainer: {
            flexDirection: 'column',
            marginBottom: 10,
            padding: 10,
        },
        entry: {
            paddingLeft: 0,
            paddingBottom: 12,
            fontSize: 11,
        },
        entryUnderline: {
            paddingLeft: 4,
            paddingTop: 3,
            paddingBottom: 3,
            fontSize: 10,
            textDecoration: 'underline',
        },
        smallEntry: {
            paddingLeft: 0,
            paddingBottom: 12,
            fontSize: 9,
        },
        bpTitle: {
            padding: '10px 0px 10px 3px',
            fontFamily: 'Roboto',
            fontWeight: 700,
            fontSize: 20,
            textDecoration: 'underline',
        },
        boxEntry: {
            paddingLeft: 4,
            paddingTop: 3,
            paddingBottom: 3,
            fontSize: 10,
        },
        sigContainer: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingLeft: 0,
            paddingRight: 30,
        },
        sigTextRight: {
            paddingLeft: 4,
            paddingTop: 3,
            paddingBottom: 3,
            fontSize: 10,
            alignItems: 'flex-end',
            justifySelf: 'flex-end',
        },
        title: {
            padding: '10px 0px 10px 3px',
            fontFamily: 'Roboto',
            fontWeight: 700,
            fontSize: 15,
        },
        titleContainer: {
            flexDirection: 'column',
            padding: '5px 15px 15px',
            justifyContent: 'center',
            textAlign: 'center',
            alignContent: 'center',
        },
    });
    const date = dayjs().format('MM/DD/YYYY');
    const { banking, owner, } = traderInfo;
    const entries = useMemo(() => {
        return [
            'BluPax Pharma Account #: ____________________',
            `Company Name:  ${pharmacy.name}`,
            `Phone Number:  ${pharmacy.phone}`,
            `Street Address:  ${pharmacy.address}`,
            `City:  ${pharmacy.city}     State:  ${pharmacy.state}     Zip:  ${pharmacy.zipCode}`,
            '',
            `Bank Name:  ${banking.bankName}`,
            `Bank City:  ${banking.bankCity}     Bank State:  ${banking.bankState}     Bank Zip:  ${banking.bankZip}`,
            `Account Type:  ${banking.accountType}     Account #:  ${banking.accountNumber}     Routing #:  ${banking.routingNumber}`,
            `Account to be debited:  ${banking.accountToBeDebited}`,
            ''
        ];
    }, [pharmacy]);
    return (_jsx(Page, { size: 'A4', wrap: false, children: _jsxs(View, { style: styles.container, children: [_jsx(View, { style: styles.imageContainer, children: _jsx(Image, { style: styles.image, src: BluePax }) }), _jsxs(View, { style: styles.titleContainer, children: [_jsx(Text, { style: styles.bpTitle, children: "BluPax Pharmaceuticals, LLC" }), _jsx(Text, { style: styles.title, children: "EFT AUTHORIZATION APPLICATION" }), _jsx(Text, { style: styles.entry, children: "For Pre-Arranged Payments (ACH Debits)" }), _jsx(Text, { style: styles.entry, children: "_X_ New             ___ Change              ___ Delete" })] }), _jsxs(View, { style: styles.entryContainer, children: [entries.map((entry, index) => (_jsx(Text, { style: styles.entry, children: entry }, index))), _jsx(Text, { style: styles.smallEntry, children: "I hereby authorize BluPax Pharmaceuticals, LLC (\"Vendor\") to initiate debit entries against my bank account indicated above and the financial institution named above to debit the same to such account." }), _jsx(Text, { style: styles.smallEntry, children: "It is understood that this agreement may be terminated by me (us) at any time by written notification to Vendor. Any such notification to Vendor shall be effective only with respect to entries initiated by Vendor after receipt of notification and a reasonable opportunity to act on it. Any such notification to Bank shall be effective only with respect to entries debited to my (our) account by Bank after receipt of such notification and a reasonable time to act on it." })] }), _jsxs(View, { style: styles.sigContainer, children: [_jsxs(View, { children: [_jsx(Text, { style: styles.boxEntry, children: `________________________ Date:  ${date}` }), _jsx(Text, { style: styles.boxEntry, children: "Authorized Signature" }), _jsx(Text, { style: styles.boxEntry }), _jsx(Text, { style: styles.entryUnderline, children: `${owner.firstName} ${owner.lastName}` }), _jsx(Text, { style: styles.boxEntry, children: "Name and Title" })] }), _jsxs(View, { children: [_jsx(Text, { style: styles.sigTextRight, children: `________________________ Date:  ${date}` }), _jsx(Text, { style: styles.sigTextRight, children: "Authorized Signature" }), _jsx(Text, { style: styles.sigTextRight }), _jsx(Text, { style: styles.sigTextRight, children: "_____________________" }), _jsx(Text, { style: styles.sigTextRight, children: "Name and Title" })] })] })] }) }));
});
